import { render, staticRenderFns } from "./AddCommissionDialog.vue?vue&type=template&id=232d0668&scoped=true"
import script from "./AddCommissionDialog.vue?vue&type=script&lang=js"
export * from "./AddCommissionDialog.vue?vue&type=script&lang=js"
import style0 from "./AddCommissionDialog.vue?vue&type=style&index=0&id=232d0668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232d0668",
  null
  
)

export default component.exports